import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div id="footer">Visas tiesības aizsargātas. {(new Date().getFullYear())}  <a href="https://www.kapuakmens.lv">SIA "KapuAkmens"</a> <br />
          <span>Izstrādāja <a href="https://www.facebook.com/girts.krumbergs" target="_blank">Ģirts Krumbergs</a></span>      
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Home/Footer.js